import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames';

export default {
  computed: {
    transportPassIsIssued() {
      return Boolean(this.visitor.transports[this.transportIndex].isIssued)
    },

    visibleTransportIssuePassButton() {
      return Boolean(
        this.visitor.access === 0 && (
          this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] ||
          this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] ||
          this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT]) &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.transportPassIsIssued
      )
    },

    visibleTransportIssuePassPeriodButton() {
      return Boolean(
        this.visitor.access === 0 &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.transportPassIsIssued
      )
    },

    visibleTransportPrintPassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        this.transportPassIsIssued
      )
    },

    visibleTransportPrintPassPeriodButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        this.transportPassIsIssued
      )
    },

    visibleTransportPrintPassPermanentAsOneButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.transportPassIsIssued
      )
    },

    visibleTransportPrintPassPermanentButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.transportPassIsIssued
      )
    },

    visibleTransportSendToSolvoButton() {
      return Boolean(this.visitor.access === 0 && this.cfgMenuTransport[ConfigMenuNames.SEND_TO_SOLVO])
    },

    visibleTransportSendToScudButton() {
      return Boolean(this.inScud === false && this.cfgMenuTransport[ConfigMenuNames.SEND_TO_SCUD])
    },

    inScud() {
      return Boolean(Number(this.transport.inScud) === 1)
    }
  },

  methods: {
    setTypeahead(transport, typeaheadList, carTypeahead) {
      const result = []
      for (const list of typeaheadList) {
        if (list.id_car_type === transport.type) {
          result.push(list)
        }
      }

      if (result.length > 0) {
        carTypeahead = result
      }

      return carTypeahead
    }
  }
}
